module.exports = __webpack_public_path__ + "5883fdc70b969b9afc765c83e9eedaab.svg";